export default {
  namespaced: true,
  state: {
    // 学历要求
    educationTypeList: [
      {
        key: 'JuniorMiddle',
        text: '初中及以下'
      },
      {
        key: 'SecondarySpecialized',
        text: '中专/中技'
      },
      {
        key: 'High',
        text: '高中'
      },
      {
        key: 'JuniorCollege',
        text: '大专'
      },
      {
        key: 'Undergraduate',
        text: '本科'
      },
      {
        key: 'Master',
        text: '硕士'
      },
      {
        key: 'Doctor',
        text: '博士'
      }
    ],
    // 职位类别
    workTypeList: [
      {
        key: 'Technology',
        text: '技术类'
      },
      {
        key: 'Product',
        text: '产品类'
      },
      {
        key: 'Design',
        text: '设计类'
      },
      {
        key: 'Operate',
        text: '运营类'
      },
      {
        key: 'Sale',
        text: '销售&咨询类'
      },
      {
        key: 'Deliver',
        text: '交付类'
      },
      {
        key: 'Service',
        text: '职能类'
      },
      {
        key: 'Management',
        text: '管理类'
      }
    ]
  },
  getters: {
    // 获取学历要求文字
    getEducationText: state => key => {
      const item =  state.educationTypeList.find(item => item.key === key)
      return item ? item.text : ''
    },
    
    // 获取职位类型要求文字
    getWorkTypeText: state => key => {
      const item =  state.workTypeList.find(item => item.key === key)
      return item ? item.text : ''
    },

  }
}
